import {
  SEND_PEER_INVITATION,
  SEND_PEER_INVITATION_FAILED,
  SEND_PEER_INVITATION_SUCCES,
  SEND_EMAIL_TA,
  SEND_EMAIL_TA_SUCCES,
  SEND_EMAIL_TA_FAILED,
} from "./constants";

import {OnRegisteredUserURL} from "./endpoints"

export function sendEmailTARequest() {
  return {
    type: SEND_EMAIL_TA,
    payload: {}
  };
}

export function sendEmailTASucces(data) {
  return {
    type: SEND_EMAIL_TA_SUCCES,
    payload: {
      data
    }
  };
}

export function sendEmailTAFailed(payload) {
  return {
    type: SEND_EMAIL_TA_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function sendEmailTa(email, name, language, password) {
  return dispatch => {
    dispatch(sendEmailTARequest());
    return fetch(
      OnRegisteredUserURL,
            {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          email: email,
          name: name,
          language: language,
          password: password
        }),
      }
    )
      .then(function(response) {
        if (response.ok) {
          return dispatch(sendEmailTASucces(response));
        }
      })
      .catch(function(error) {
        return dispatch(sendEmailTAFailed(error));
      });
  };
}

export function sendPeerInvitationRequest() {
  return {
    type: SEND_PEER_INVITATION,
    payload: {}
  };
}

export function sendPeerInvitationSucces(data) {
  return {
    type: SEND_PEER_INVITATION_SUCCES,
    payload: {
      data
    }
  };
}

export function sendPeerInvitationFailed(payload) {
  return {
    type: SEND_PEER_INVITATION_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function sendPeerInvitation(
  email,
  name,
  language,
  shareLink,
  endpoint,
  owner
) {
  return dispatch => {
    dispatch(sendPeerInvitationRequest());
    return fetch(endpoint, {
      method: "POST",
      mode: "no-cors",

      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        email: email,
        name: name,
        language: language,
        shareLink: shareLink,
        ownerName: owner
      }),
    })
      .then(function(response) {
        if (response.ok) {
          return dispatch(sendPeerInvitationSucces(response));
        }
      })
      .catch(function(error) {
        return dispatch(sendPeerInvitationFailed(error));
      });
  };
}




// WEBPACK FOOTER //
// ./src/modules/emails/actions.js